var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ul',{attrs:{"id":"nav"}},_vm._l((_vm.headerMenuConfig),function(item){return _c('li',{key:item.path},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])],1)}),0),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }